import { createReducer, on } from '@ngrx/store';
import {IEmployeesState, initialEmployeesState} from './employees.state';
import {
  EmployeesError,
  EmployeesLoaded,
  EmployeesLoading,
} from './employees.actions';

export const initialState: IEmployeesState = {
  employees: [],
  loading: false,
};

const setEmployees = (state: IEmployeesState, { employees }: { employees: [] }) => {
  let newState: IEmployeesState = {
    ...state,
    employees,
    loading: false,
  };
  return newState;
}

const _EmployeesReducer = createReducer<IEmployeesState>(
  initialEmployeesState,

   on(EmployeesLoading, (state) => ({
     ...state,
     loading: true,
   })),

   on(EmployeesError, (state) => ({
    ...state,
    loading: false,
  })),
  
  on(EmployeesLoaded, setEmployees),
);

export function employeesReducer(state: IEmployeesState, action): IEmployeesState {
  return _EmployeesReducer(state, action);
}
